import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPivotLeads = createAsyncThunk(
  'fetchPivotLeads',
  async ({ jwtBearer }) => {
    const response = await fetch(`${BASE_URL}pipeline/leads/summary/`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}`
      }
    })
    return response.json()
  }
)

const leadsPivotSlice = createSlice({
  name: 'leadsPivotReports',
  initialState: {
    isLoadingPivot: false,
    leadsPivotdata: null,
    isErrorPivot: false
  },
  extraReducers: builder => {
    builder.addCase(fetchPivotLeads.pending, (state, action) => {
      state.isLoadingPivot = true
      state.isErrorPivot = false;
    })
    builder.addCase(fetchPivotLeads.fulfilled, (state, action) => {
      state.isLoadingPivot = false
      state.leadsPivotdata = action.payload
      console.log("state.leadsPivotData",state.leadsPivotdata)
    })
    builder.addCase(fetchPivotLeads.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isErrorPivot = true
    })
  }
})

export default leadsPivotSlice.reducer